import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { api } from '../../app/Api/ApiSlice'
import InfiniteScroll from 'react-infinite-scroll-component'
import { toast } from 'react-toastify'
import Loader from '../../components/Loader'
import ProductCard from '../../components/ProductCard'

// This component shows all store products
const Products = () => {
    const [products, setProducts] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [hasMore, setHasMore] = useState(true)
    const [page, setPage] = useState(1)

    const { name } = useParams()

    useEffect(() => {
        const getProducts = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/products?page=${page}`)
                if (response) {
                    setProducts(prev => [...prev, ...response.data])
                    setHasMore(response.data.length < 20)
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Failed to fetch products')
            } finally {
                setIsLoading(false)
            }
        }

        getProducts()
    }, [page, name])

    const handleRefresh = () => {
        setProducts([])
        setPage(1)
    }

    return (
        <div className=''>
            <h3 className="page-header-title">{name}</h3><span>Products</span>
            {isLoading && page === 1 && <Loader />}
            {!isLoading && products.length === 0 && <p>No products in this store</p>}

            {products.length > 0 && (

                <InfiniteScroll
                    dataLength={products.length}
                    next={() => setPage(prev => prev + 1)}
                    hasMore={hasMore}
                    loader={<Loader />}
                    refreshFunction={handleRefresh}
                    pullDownToRefresh
                >
                    <div className="store-products-page-wrapper">
                        {products.map(product => (
                            <ProductCard product={product} key={product._id} />

                        ))}   </div>

                </InfiniteScroll>

            )}

            {!hasMore && products.length > 0 && (
                <p style={{ textAlign: 'center', marginTop: '1rem' }}>No more products</p>
            )}
        </div>
    )
}

export default Products
